export default "assets/images/logo-bio-a0efd6f1.png";